import { designTokens } from "utils/designSystem";

const linkButton = {
  display: "inline-flex",
  alignItems: "center",
  gap: designTokens.spacing.xs,
  border: "none",
  background: "none",
  color: designTokens.colors.primary,
  cursor: "pointer",
  fontSize: "13px",
  padding: 0,
  whiteSpace: "nowrap",
};

export const pdStyles = {
  label: {
    display: "block",
    fontSize: "13px",
    fontWeight: "600",
    color: designTokens.colors.text.secondary,
    margin: `0 0 ${designTokens.spacing.xs}`,
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing.sm,
    flexWrap: "wrap",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing.md,
    marginBottom: designTokens.spacing.xl,
  },
  textarea: {
    width: "100%",
    minHeight: "110px",
    padding: designTokens.spacing.md,
    border: `1px solid ${designTokens.colors.border}`,
    borderRadius: designTokens.borderRadius.md,
    fontSize: "14px",
    lineHeight: 1.6,
    resize: "vertical",
    boxSizing: "border-box",
    fontFamily: "inherit",
  },
  hint: { fontSize: "12px", color: designTokens.colors.text.muted, margin: 0 },
  muted: { fontSize: "13px", color: designTokens.colors.text.muted, margin: 0 },
  subTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: designTokens.spacing.sm,
    fontSize: "15px",
    fontWeight: "700",
    color: designTokens.colors.text.primary,
    margin: `${designTokens.spacing.xl} 0 ${designTokens.spacing.sm}`,
  },
  content: {
    whiteSpace: "pre-line",
    wordBreak: "break-all",
    lineHeight: 1.7,
    color: designTokens.colors.text.secondary,
    backgroundColor: "#fafbfc",
    borderRadius: designTokens.borderRadius.lg,
    padding: designTokens.spacing.lg,
    margin: 0,
  },
  linkButton,
  dangerLink: { ...linkButton, color: designTokens.colors.danger },
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing.md,
  },
  card: {
    border: `1px solid ${designTokens.colors.borderLight}`,
    borderRadius: designTokens.borderRadius.lg,
    padding: designTokens.spacing.lg,
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing.sm,
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: designTokens.spacing.sm,
    flexWrap: "wrap",
  },
  fileList: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing.xs,
  },
  fileItem: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing.sm,
    fontSize: "13px",
    padding: `${designTokens.spacing.sm} ${designTokens.spacing.md}`,
    border: `1px solid ${designTokens.colors.borderLight}`,
    borderRadius: designTokens.borderRadius.md,
  },
  fileName: { flex: 1, minWidth: 0, wordBreak: "break-all" },
  fileTitle: { fontWeight: "600", marginRight: designTokens.spacing.sm },
  fileMeta: { color: designTokens.colors.text.muted, whiteSpace: "nowrap" },
  tableWrapper: { overflowX: "auto" },
  table: { width: "100%", borderCollapse: "collapse", fontSize: "13px" },
  th: {
    textAlign: "left",
    padding: designTokens.spacing.sm,
    borderBottom: `1px solid ${designTokens.colors.border}`,
    color: designTokens.colors.text.tertiary,
    fontWeight: "600",
    whiteSpace: "nowrap",
  },
  td: {
    padding: designTokens.spacing.sm,
    borderBottom: `1px solid ${designTokens.colors.borderLight}`,
    verticalAlign: "top",
  },
  nowrap: { whiteSpace: "nowrap" },
};

export const disabledStyle = (disabled) =>
  disabled ? { opacity: 0.5, cursor: "not-allowed" } : {};
